var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWarnBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 24.9997H21.6663V28.333H18.333V24.9997ZM18.333 11.6663H21.6663V21.6663H18.333V11.6663ZM19.983 3.33301C10.783 3.33301 3.33301 10.7997 3.33301 19.9997C3.33301 29.1997 10.783 36.6663 19.983 36.6663C29.1997 36.6663 36.6663 29.1997 36.6663 19.9997C36.6663 10.7997 29.1997 3.33301 19.983 3.33301ZM19.9997 33.333C12.633 33.333 6.66634 27.3663 6.66634 19.9997C6.66634 12.633 12.633 6.66634 19.9997 6.66634C27.3663 6.66634 33.333 12.633 33.333 19.9997C33.333 27.3663 27.3663 33.333 19.9997 33.333Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarnBig);
export default __webpack_public_path__ + "static/media/ic_warn_big.779f0b3f412664d00db749bb922ca493.svg";
export { ForwardRef as ReactComponent };